package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.domain.repository.SystemConfigRepository
import com.clany.backoffice.model.SystemConfigResponse
import io.ktor.client.request.parameter
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.HttpMethod
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class SystemConfigRepositoryImpl(
    private val networkClient: NetworkClient
) : SystemConfigRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun getSystemConfigs(page: Int, pageSize: Int, query: String?): Result<List<SystemConfigResponse>> {
        return networkClient.request<List<SystemConfigResponse>>("$baseUrl/api/metadata") {
            parameter("page", page)
            parameter("limit", pageSize)
            if (query != null) parameter("q", query)
        }
    }

    override suspend fun getSystemConfigById(id: String): Result<SystemConfigResponse> {
        return networkClient.request<SystemConfigResponse>("$baseUrl/api/metadata/$id")
    }

    override suspend fun createSystemConfig(config: SystemConfigResponse): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/metadata", HttpMethod.Post, config) {
            contentType(ContentType.Application.Json)
        }
    }

    override suspend fun updateSystemConfig(id: String, config: SystemConfigResponse): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/metadata/$id", HttpMethod.Put, config) {
            contentType(ContentType.Application.Json)
        }
    }

    override suspend fun deleteSystemConfig(id: String): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/metadata/$id", HttpMethod.Delete)
    }
}
